import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../design-system/form-field";
import {ProfileFormValues} from "../../schema-validation";

export function ProfileFirstNameFormField() {
  const {control} = useFormContext<ProfileFormValues>();

  return (
    <FormField
      id="firstName"
      label="First name"
      renderInput={(id) => (
        <Controller
          control={control}
          name="firstName"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <Space size={4} direction="vertical" style={{display: "flex"}}>
                <Input
                  id={id}
                  status={error?.message ? "error" : ""}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="large"
                  value={value === null ? undefined : value}
                  placeholder="Enter your first name"
                  ref={ref}
                />
              </Space>
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
